export default "__VITE_ASSET__de277542__"